module.exports = __webpack_public_path__ + "img/bottom_icon03.2b1fa49.png";